import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotTags from './components/HotTags';
import MemeLibrary from './components/MemeLibrary';
import GifSection from './components/GifSection';
import Guide from './components/Guide';
import About from './components/About';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function HomePage() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero onPick={() => document.getElementById('library')?.scrollIntoView({ behavior: 'smooth' })} />
        <HotTags />
        <MemeLibrary />
        <GifSection />
        <Guide />
        <About />
        <Faq />
      </main>
      <Footer />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      )}

      {/* 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: '吃瓜表情站',
              alternateName: '吃瓜群众表情包大全',
              url: 'https://zuicard.cn',
              description:
                '专为吃瓜群众打造的趣味表情包配图库，海量吃瓜专用表情、动图实时更新，覆盖震惊、无语、偷笑看戏、蹲后续等围观场景。',
              inLanguage: 'zh-CN',
            },
            {
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '吃瓜表情包真的免费吗？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '是的，本站所有吃瓜群众表情图、吃瓜动图均免费供围观场景使用，无需注册即可浏览和保存。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '怎么把表情包保存到手机或电脑？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '在表情大全或动图专区里点击任意卡片即可放大预览，之后可通过系统方式保存到相册或本地。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '表情包多久更新一次？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '我们每天都会上新，围绕最新围观热点、热门梗和常见表情场景进行补充。',
                  },
                },
              ],
            },
          ]),
        }}
      />
    </>
  );
}